import { IconWrapper } from '../runtime';
export default IconWrapper('insert-shape', false, function (h, props) {
  return h("svg", {
    "attrs": {
      "width": props.size,
      "height": props.size,
      "viewBox": "0 0 16 16",
      "fill": "none"
    }
  }, [h("path", {
    "attrs": {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      "d": "M8 16C12.4183 16 16 12.4183 16 8C16 3.58172 12.4183 0 8 0C3.58172 0 0 3.58172 0 8C0 12.4183 3.58172 16 8 16Z",
      "fill": "#3FB772",
      "vector-effect": "non-scaling-stroke"
    }
  }), h("path", {
    "attrs": {
      "d": "M8.75 4.80357C8.75 4.35977 8.39023 4 7.94643 4C7.50263 4 7.14286 4.35977 7.14286 4.80357V7.14285H4.80357C4.35977 7.14285 4 7.50262 4 7.94642C4 8.39022 4.35977 8.75 4.80357 8.75H7.14286V11.0893C7.14286 11.5331 7.50263 11.8929 7.94643 11.8929C8.39023 11.8929 8.75 11.5331 8.75 11.0893V8.75H11.0893C11.5331 8.75 11.8929 8.39022 11.8929 7.94642C11.8929 7.50262 11.5331 7.14285 11.0893 7.14285H8.75V4.80357Z",
      "fill": "white",
      "vector-effect": "non-scaling-stroke"
    }
  })]);
});